import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject ,Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DigitalSignatureService {
    private apiUrl = environment.apiUrl + '/digital_signatures/';  // Usa la variable global
    private http = inject(HttpClient); // Inyección sin constructor

    getByUserId(id: String): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}getByUserId/${id}`);
    }
    save(formData:FormData): Observable<any> {
        return this.http.post<any>(this.apiUrl+'save',formData);
    }
    delete(id: String): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}delete/${id}`);
    }
    update(id: string, formData: FormData): Observable<any> {
        return this.http.put<any>(`${this.apiUrl}update/${id}`, formData);
    }
}